import usePermissions from 'hooks/usePermissions'
import DashboardTables from 'pages/sections/DashboardTables'
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import PageWrapper from 'ui/atoms/PageWrapper'
import TitleWrapper from 'ui/atoms/TitleWrapper'
import PageTitle from 'ui/molecules/PageTitle'
import { ZentakeContext } from 'utils/ZentakeContext'

import { invalidateLoadStripeCustomer } from '@/queries/payments/useLoadStripeCustomer'

import SearchClientBar from './sections/SearchClientBar'
import SendButtons from './sections/SendButtons'

export default function Dashboard() {
  const [dashboardSearch] = useState('')

  const { updateMessagesAndResponses } = useContext(ZentakeContext)

  const { canViewResponse } = usePermissions()

  useEffect(() => {
    const promises = []
    if (canViewResponse) promises.push(updateMessagesAndResponses())
    promises.push(invalidateLoadStripeCustomer())

    async function init() {
      await Promise.all(promises)
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper className="pb-11">
      <Helmet>
        <title>Dashboard/Zentake</title>
      </Helmet>
      <PageTitle text="Dashboard" />
      <div className="mx-auto max-w-screen-xl lg:flex lg:flex-row lg:items-center">
        <SendButtons />
        <TitleWrapper>
          <SearchClientBar />
        </TitleWrapper>
      </div>

      <DashboardTables searchTerm={dashboardSearch} />
    </PageWrapper>
  )
}
